import React, { useContext } from "react";
import styles from "@/page-components/reporting/reporting.module.css";
import { useSearchParams } from "react-router-dom";
import { ReportingContext } from "../reporting-context-file";
import { Tab, Tabs } from "react-bootstrap";
import idleStyles from "@/page-components/idle-resource/idle.module.css";

const HeaderTabsComponents = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const context = useContext(ReportingContext);

  const handleChangeTab = (e) => {
    searchParams.delete("page");
    searchParams.delete("itemsPerPage");
    setSearchParams(searchParams);
    context.setSelectedTab(e);
  };

  return (
    <div className={styles.inner_main_container}>
      <span className={styles.reporting_name}>Reporting</span>

      <div className={styles.tabs_updated_at}>
        <div className="btn-combo__Container">
          <Tabs
            className={idleStyles.mytabs_button}
            defaultActiveKey={context.SelectedTab}
            fill
            onSelect={(e) => handleChangeTab(e)}
            style={{ gap: "4px", marginBottom: "0px" }}
          >
            <Tab eventKey="Reporting Center" title="Reporting Center"></Tab>
            <Tab eventKey="Reports Library" title="Reports Library" />
          </Tabs>
        </div>
        <span className={styles.updated_at_css}>Updated Today at 7:05AM</span>
      </div>
    </div>
  );
};

export default HeaderTabsComponents;
